import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './components/Home'
import Projects from './components/Projects'
import About from './components/About'
import Admin from './components/Admin'
import SignUp from './components/SignUp';
import NavigationBar from './components/NavigationBar'
import ProjectDetails from './components/Projects/ProjectDetails';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';

import './App.css';
import 'animate.css';
import { getDatabase, ref, onValue, set, push, child } from "firebase/database";
import { useDispatch } from 'react-redux';
import { setLoggedInUser } from './components/Login/redux/actions';
import { fbApp } from './firebase-config';
import Toasts from './components/Shared/Toasts';
import Pitches from './components/Projects/Pitches';
import User from './components/User';

const fbBatabase = getDatabase(fbApp);

export const dbRef = ref(fbBatabase, '/');

export function addProspect(name, email, title, project, imgurl) {

  let uid = push(child(ref(fbBatabase), 'prospects')).key;
  if (isEmpty(name)) { name = "John Doe" };
  if (isEmpty(email)) { email = "no@mail.com" };
  if (isEmpty(title)) { title = "Unknown" };
  if (isEmpty(project)) { project = "All" };
  if (isEmpty(imgurl)) { imgurl = "https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/users%2Fincognito.jpeg?alt=media&token=5eeccf93-20ed-45a6-9e29-b00b982adb1a" };

  set(ref(fbBatabase, '/prospects/' + uid), {
    username: name,
    email: email,
    title: title,
    project: project,
    imgurl: imgurl
  });
}

export function addUser(name, business, email, title, imgUrl) {

  if (isEmpty(name)) { name = "John Dow" };
  if (isEmpty(business)) { business = "Business" };
  if (isEmpty(email)) { email = "no@mail.com" };
  if (isEmpty(title)) { title = "Unknown" };
  if (isEmpty(imgUrl)) { imgUrl = "Unknown" };
  // if(isEmpty(project)) { project = "All"};
  // if(isEmpty(imgurl)) { imgurl = "https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/users%2Fincognito.jpeg?alt=media&token=5eeccf93-20ed-45a6-9e29-b00b982adb1a"};

  let uid = push(child(ref(fbBatabase), 'users')).key;
  set(ref(fbBatabase, '/users/' + uid), {
    name: name,
    business: business,
    email: email,
    title: title,
    imgUrl: imgUrl
  });
}


export function addPitch(title, description, contact, imgUrl) {

  let uid = push(child(ref(fbBatabase), 'pitches')).key;

  set(ref(fbBatabase, '/pitches/' + uid), {
    title: title,
    description: description,
    contact: contact,
    imgUrl: imgUrl
  });
}

function isEmpty(_what) {
  if (typeof _what === 'undefined') {
    return true
  }

  if (_what === '') {
    return true
  }
  if (_what) {
    return false
  }
  return true // weird catchall
}

function App() {

  const [loggedIn, setLoggedIn] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      setLoggedIn(true); // <-- update loggedIn state in parent component
      dispatch(setLoggedInUser(JSON.parse(localStorage.getItem("user"))));
    }
  }, []);

  return (
    <div className="App">
      <Router>
        <Toasts />
        <NavigationBar loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route exact path="/projects" element={<Projects />}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/home/:pitch" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/admin" element={<Admin />}></Route>
          <Route path="/signup" element={<SignUp />}></Route>
          <Route path="/user/:userId" element={<User />}></Route>
          <Route path="/login" element={<Login setLoggedIn={setLoggedIn} />}></Route>
          <Route path="/projects/pitches" element={<Pitches />}></Route>
          <Route path="/projects/completed" element={<Projects />}></Route>
          <Route path="/projects/ongoing" element={<Projects />}></Route>
          <Route path="/projects/pitches/:pitch" element={<Pitches />}></Route>
          <Route path="/resetpassword" element={<ResetPassword />}></Route>
          <Route exact path="/project/:title" element={<ProjectDetails />} />
          <Route path="*" element={<Home />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
